import { render } from "./BoardWrite.vue?vue&type=template&id=777fe6d4"
import script from "./BoardWrite.vue?vue&type=script&lang=js"
export * from "./BoardWrite.vue?vue&type=script&lang=js"

import "./BoardWrite.vue?vue&type=style&index=0&id=777fe6d4&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__